import "./TeamDetail.scss";
import Offcanvas from "react-bootstrap/Offcanvas";
import { images } from "../../../../utils/images";
import { GoArrowLeft } from "react-icons/go";
import { GoArrowRight } from "react-icons/go";

import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { RiCloseLargeLine } from "react-icons/ri";
import { baseUrl } from "../../../../utils/apiData";

const TeamDetail = ({ slide, setSlide, isDetail, setIsDetail, dataList }) => {
  const gotop = () => {
    const section = document.getElementById("profile");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const prevHandler = () => {
    gotop();
    setSlide((prev) => prev - 1);
  };
  const nextHandler = () => {
    gotop();
    setSlide((prev) => prev + 1);
  };
  return (
    <Offcanvas
      show={isDetail}
      onHide={() => setIsDetail(false)}
      placement="end"
      className="team_detail"
    >
      <Offcanvas.Body>
        <div id="profile"></div>
        <button className="close" onClick={() => setIsDetail(false)}>
          <RiCloseLargeLine />
        </button>
        <div className="info">
          <h4 className="gold">{dataList[slide]?.name}</h4>
          <p style={{ opacity: "0.8" }} className="gold">{dataList[slide]?.proffession}</p>
          <div className="profile">
            <img src={`${baseUrl}/${dataList[slide]?.image}`} alt="Profile" />
          </div>
          <div className="profile_info" dangerouslySetInnerHTML={{ __html: dataList[slide]?.content }} />
          <div className="social">
            {dataList[slide]?.instagram_link && (
              <a href={dataList[slide]?.instagram_link} target="_blank" className="gold">
                <FaInstagram />
              </a>
            )}

            {dataList[slide]?.linkedin_link && (
              <a href={dataList[slide]?.linkedin_link} target="_blank" className="gold">
                <FaLinkedinIn />
              </a>
            )}

            {dataList[slide]?.facebook_link && (
              <a href={dataList[slide]?.facebook_link} target="_blank" className="gold">
                <FaFacebookF />
              </a>
            )}
          </div>
        </div>
        <div className="bottom_buttons">
          <button type="button" onClick={prevHandler} disabled={slide === 0}>
            <GoArrowLeft />
            Prev
          </button>
          <button
            type="button"
            onClick={nextHandler}
            disabled={slide === dataList?.length - 1}
          >
            Next <GoArrowRight />
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default TeamDetail;
